import { hardNavigation } from "../../../utils/hard-navigation.util";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";

@Injectable({ providedIn: "root" })
export class ExternalRedirectGuard  {
  canActivate(route: ActivatedRouteSnapshot): boolean {
    hardNavigation.navigate(route.data["externalUrl"]);
    return false;
  }
}
